export class Controller {

    /** @ngInject */
    constructor($scope,
                $state,
                $uibModal,
                Account,
                Alert,
                CorporateSettingsService,
                DestructiveOperationModal,) {
        this.$scope = $scope;
        this.$state = $state;
        this.$uibModal = $uibModal;
        this.Account = Account;
        this.Alert = Alert;
        this.DestructiveOperationModal = DestructiveOperationModal;
    }

    $onInit() {
        const companyId = this.companyId = this.$state.params.companyId;
    }

}


// WEBPACK FOOTER //
// ./src/portal/states/company/policies/policies.controller.js